<template>
    <div class="PositionManagement">
      <PositionManagement/>
    </div>
  </template>
  
  <script>
  // @ is an alias to /src
  import PositionManagement from '@/components/PositionManagement.vue'
  
  export default {
    name: 'admin-PositionManagement-view',
    components: {
      PositionManagement
    }
  }
  </script>
  